module.exports = __webpack_public_path__ + "img/ding.4e236bfc.png";